var _circle, _circle2, _circle3, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 385,
    height: 385,
    viewBox: "0 0 385 385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 192.5,
    r: 192.5,
    fill: "#FFE9E7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.501,
    cy: 192.5,
    r: 96.8021,
    fill: "#FFB8B2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.498,
    cy: 192.5,
    r: 48.217,
    fill: "#D13325"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176 208.354L210.688 177",
    stroke: "#ECF3EB",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210.688 208.354L176 177",
    stroke: "#ECF3EB",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailed);
export default __webpack_public_path__ + "static/media/paymentFailed.a9a10ab29eab4e4720f9732cbfbddfce.svg";
export { ForwardRef as ReactComponent };